import { createUseStyles, Styles } from '@pff-consumer/tweed-ui/web-styles'

interface FeatureCardStyles {
  containerCard: Styles
  image: Styles
  title: Styles
  subTitle: Styles
  cardFeatureContainer: Styles
  feature: Styles
  featureText: Styles
}

interface FeatureCardStyleProps {
  isDesktop: boolean
}

export const useStyles = createUseStyles<FeatureCardStyles, FeatureCardStyleProps>((theme) => {
  return {
    containerCard: ({ isDesktop }) => {
      return {
        backgroundColor: theme.colors.inverseTextColor,
        padding: theme.calcUnit(theme.spacing.s3),
        borderRadius: theme.calcUnit(theme.borderRadius.roundedDefault),
        marginTop: theme.calcUnit(theme.spacing.s3),
        marginBottom: theme.calcUnit(theme.spacing.s10),
        width: isDesktop ? '80%' : '95%',
        marginLeft: isDesktop ? theme.calcUnit(theme.spacing.s10) : 0,
        background: isDesktop
          ? `linear-gradient(to right, ${theme.colors.inverseBackgroundColor} 0%,rgba(0,0,0,0) 10%,rgba(0,0,0,0) 90%, ${theme.colors.inverseBackgroundColor} 100%)`
          : undefined,
      }
    },
    image: {
      width: '100%',
    },
    title: {
      fontFamily: 'Archivo',
      fontWeight: 600,
      fontSize: theme.calcUnit(12),
      lineHeight: theme.calcUnit(18),
      color: '#D3D3D3',
      textAlign: 'left',
      marginTop: theme.calcUnit(theme.spacing.s3),
    },
    subTitle: {
      fontFamily: 'Archivo',
      fontWeight: 700,
      fontSize: theme.calcUnit(16),
      lineHeight: theme.calcUnit(24),
      color: theme.colors.webInverseTextColor,
      textAlign: 'left',
      marginTop: theme.calcUnit(theme.spacing.s1),
    },
    cardFeatureContainer: {
      display: 'flex',
      flexDirection: 'column',
      marginTop: theme.calcUnit(theme.spacing.s1),
    },
    feature: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.calcUnit(10),
      marginTop: theme.calcUnit(theme.spacing.s1),
    },
    featureText: {
      fontFamily: 'Archivo',
      fontWeight: 400,
      fontSize: theme.calcUnit(16),
      lineHeight: theme.calcUnit(24),
      color: theme.colors.webInverseTextColor,
      textAlign: 'left',
    },
  }
})
